/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Participation_Agreement_TitleInputs */

const en_admin_participation_agreement_title = /** @type {(inputs: Admin_Participation_Agreement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation agreement (PDF)`)
};

const de_admin_participation_agreement_title = /** @type {(inputs: Admin_Participation_Agreement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmevereinbarung (PDF)`)
};

/**
* | output |
* | --- |
* | "Participation agreement (PDF)" |
*
* @param {Admin_Participation_Agreement_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_participation_agreement_title = /** @type {((inputs?: Admin_Participation_Agreement_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Participation_Agreement_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_participation_agreement_title(inputs)
	return en_admin_participation_agreement_title(inputs)
});